import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
        <div style={{ fontSize: '1.2em' }}>[Company Logo]</div>
        <h1 style={{ fontSize: '2em', margin: 0 }}>Privacy Policy</h1>
        <div style={{ fontSize: '0.9em' }}>Effective Date: [Insert Date]</div>
      </header>

      <p style={{ lineHeight: 1.6, marginBottom: '15px' }}>
        At [Your Company Name], we value your privacy and are dedicated to protecting your personal information. This Privacy Policy explains how we handle your data when you use our ticketing tool web application.
      </p>

      <section style={{ marginBottom: '20px' }}>
        <h2 style={{ fontSize: '1.5em', marginBottom: '10px' }}>Information We Collect</h2>

        <h3 style={{ fontSize: '1.2em', marginBottom: '8px' }}>Personal Data You Provide:</h3>
        <ul style={{ marginBottom: '15px', paddingLeft: '20px' }}>
          <li>Account information: Name, email, contact details, payment info, transaction history.</li>
          <li>User-generated content: Ticket details, uploaded content.</li>
          <li>Communication data: Name, message contents.</li>
        </ul>

        <h3 style={{ fontSize: '1.2em', marginBottom: '8px' }}>Technical Data:</h3>
        <ul style={{ marginBottom: '15px', paddingLeft: '20px' }}>
          <li>Log data: IP address, browser type, device info, usage statistics.</li>
          <li>Cookies: Usage patterns, enhanced experience.</li>
        </ul>
      </section>

      <section style={{ marginBottom: '20px' }}>
        <h2 style={{ fontSize: '1.5em', marginBottom: '10px' }}>How We Use Your Data</h2>
        <ul style={{ marginBottom: '15px', paddingLeft: '20px' }}>
          <li>Providing and maintaining our Service.</li>
          <li>Processing transactions, customer inquiries.</li>
          <li>Improving our Service, creating new features.</li>
          <li>Ensuring security, preventing fraud.</li>
          <li>Complying with legal requirements.</li>
        </ul>
      </section>

      <section style={{ marginBottom: '20px' }}>
        <h2 style={{ fontSize: '1.5em', marginBottom: '10px' }}>Sharing Your Information</h2>
        <ul style={{ marginBottom: '15px', paddingLeft: '20px' }}>
          <li>Service providers: Payment processing, hosting, communication.</li>
          <li>Legal authorities: When required by law.</li>
        </ul>
      </section>

      <section style={{ marginBottom: '20px' }}>
        <h2 style={{ fontSize: '1.5em', marginBottom: '10px' }}>Data Security</h2>
        <p style={{ lineHeight: 1.6, marginBottom: '15px' }}>
          Security measures implemented. Note: Complete security cannot be guaranteed.
        </p>
      </section>

      <section style={{ marginBottom: '20px' }}>
        <h2 style={{ fontSize: '1.5em', marginBottom: '10px' }}>Your Rights</h2>
        <p style={{ lineHeight: 1.6, marginBottom: '15px' }}>
          Access, correct, delete personal data (based on jurisdiction). Contact us at [Insert contact info] for requests.
        </p>
      </section>

      <section style={{ marginBottom: '20px' }}>
        <h2 style={{ fontSize: '1.5em', marginBottom: '10px' }}>Changes to This Policy</h2>
        <p style={{ lineHeight: 1.6, marginBottom: '15px' }}>
          Policy may be updated. Changes posted on website, updated date reflected.
        </p>
      </section>

      <section style={{ marginBottom: '20px' }}>
        <h2 style={{ fontSize: '1.5em', marginBottom: '10px' }}>Contact Us</h2>
        <p style={{ lineHeight: 1.6, marginBottom: '10px' }}>
          [Your Company Name]<br />
          [Your Contact Information]<br />
          <a href="mailto:[Your Email Address]">[Your Email Address]</a>
        </p>
      </section>

      <footer style={{ textAlign: 'center', fontSize: '0.8em', padding: '20px 0', borderTop: '1px solid #eee' }}>
        Copyright [Year] [Your Company Name]. All rights reserved. [Links to Terms of Service, etc.]
      </footer>
    </div>
  );
};

export default PrivacyPolicy;